import { Stack } from 'expo-router';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import { AuthContext, AuthContextProps } from 'shared/providers/auth';
import theme from 'shared/styles/theme';

const ChangePasswordSuccess = () => {
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'changePasswordSuccess',
  });

  const { handleLogout } = useContext<AuthContextProps>(AuthContext);

  const logout = () => {
    void handleLogout({ shouldNavigateToLogin: true });
  };

  const onNextButtonAction = () => {
    logout();
  };

  useBackHandler(logout);

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
          gestureEnabled: false,
        }}
      />

      <SuccessScreen
        visual="LOCK_A"
        titleText={translatedText('title')}
        content={
          <BodyBaseText style={styles.textAlignment} numberOfLines={0}>
            {translatedText('description')}
          </BodyBaseText>
        }
        primaryButton={{
          label: translatedText('button.next'),
          onPress: () => {
            onNextButtonAction();
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    display: 'flex',
    flex: 1,
    flexGrow: 1,
    justifyContent: 'flex-start',
    minWidth: `100%`,
    paddingVertical: theme.spacing.m,
  },
  textAlignment: {
    textAlign: 'center',
  },
});

export default ChangePasswordSuccess;
